module.exports = __webpack_public_path__ + "static/media/blog5.526ed2e6.jpg";